import React, { useState } from 'react';
import axios from 'axios';

const ReviewerLogin = () => {
  const [formData, setFormData] = useState({ UserName: '', Password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const API = process.env.REACT_APP_API_BASE_URL;
  const PlatformID = localStorage.getItem('platformID');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      // Build payload directly—no async state delay
      const payload = { ...formData, PlatformID };

      const response = await axios.post(`${API}/api/reviewer/login`, payload);

      const { token, reviewerID, ReviewerName } = response.data;

      localStorage.setItem('token', token);
      localStorage.setItem('reviewerID', reviewerID);
      localStorage.setItem('ReviewerName', ReviewerName);

      // Optional: setSuccess(`Welcome, ${ReviewerName}! Login successful.`);
      window.location.href = '/reviewer/dashboard';
    } catch (err) {
      const message = err.response?.data?.message || 'An error occurred';
      setError(message);
    }
  };

   // //  Forgot Password Handler
  const handleForgotPassword = async () => {
    const email = window.prompt('Enter your registered email to receive a password reset link:');
    if (!email) return;

    try {
      const response = await axios.post(`${API}/api/reviewer/forgot-password`, { email });
      alert('Password reset link has been sent to your registered email.');
    } catch (err) {
      alert(
        err.response?.data?.message || 'Failed to send reset link. Please try again later.'
      );
    }
  };

  return (
    <div className="container mt-5 d-flex justify-content-center">
      <div className="card shadow-sm p-4" style={{ width: '100%', maxWidth: '420px' }}>
        <h3 className="page-title text-center mb-4 ">Reviewer Login</h3>

        {error && <div className="alert alert-danger py-2">{error}</div>}
        {success && <div className="alert alert-success py-2">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="UserName" className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control"
              id="UserName"
              name="UserName"
              value={formData.UserName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="Password" className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              id="Password"
              name="Password"
              value={formData.Password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">Login</button>
        </form>
        {/*  Forgot Password link */}
        <div className="text-center mt-3">
          <button
            className="btn btn-link text-decoration-none p-0"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewerLogin;
